import axios, { AxiosPromise } from 'axios';

import { IBarcodeRange } from '../../../@types/model/masterData/barcodeRange/barcodeRange';
import { IBarcodeRangeUpsert } from '../../../@types/model/masterData/barcodeRange/barcodeRangeUpsert';

export default class BarcodeRangeHttpService {
    public static getBarcodeRangeData() : AxiosPromise<Array<IBarcodeRange>> {
        return axios.get(`${API_URL}/v1/BarcodeRange/GetAllWeb`);
    }

    public static addOrUpdateBarcodeRange(upsert : IBarcodeRangeUpsert) : AxiosPromise<IBarcodeRange> {
        return axios.post(`${API_URL}/v1/BarcodeRange/PostBarcodeRange`, upsert);
    }

    public static deleteBarcodeRange(barcodeRangeId : number) : AxiosPromise<IBarcodeRange> {
        return axios.delete(`${API_URL}/v1/BarcodeRange/Delete`, {
            params : { barcodeRangeId },
        });
    }
}
